import { FormattedMessage } from 'react-intl';
import React, { useCallback } from 'react';

import { Button } from 'ui-components/components/button';
import buttonTextStyle from 'ui-components/components/button/button-text.module.less';

import EditShipFromModal from './edit-ship-from-modal';
import { useCreateReturnContext } from '../../../../context/create-return-provider';
import { useModal } from '../../../../../../hooks/use-modal';
import { usePendingReturnContext } from '../../../../context/pending-return-context-provider';

import messages from './messages';
import style from './style.module.less';

export const ShipFromLabel = () => {
  const { open, close, isOpen } = useModal();
  const { resetFormState } = useCreateReturnContext();
  const { isPendingReturnSelected: canEditAddress } = usePendingReturnContext();

  const onClickEditReturnAddress = useCallback(() => {
    resetFormState();
    open();
  }, [open, resetFormState]);

  return (
    <>
      <FormattedMessage {...messages.shipFromLabel} />
      {canEditAddress && (
        <div className={style['address-label-actions']}>
          <Button className={buttonTextStyle['button-text']} onClick={onClickEditReturnAddress} theme='link'>
            <FormattedMessage {...messages.editShipFromAddressButton} />
          </Button>
        </div>
      )}
      {isOpen && <EditShipFromModal onClose={close} />}
    </>
  );
};
